import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Table,
  Modal,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import {
  gatAllOackage,
  deletePackage,
  getb2b,
  assignPackage,
  getassignedPackage,
  removeassigedorg,
  CataloguePackageActivity,
} from "../../../Listfunction";
import LoadingSpinner from "views/Components/loadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class PackageActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityData: [],
      userRole: "",
      loading: false,
      noRecordFound: false,
      title_search: "",
      page: 1,
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      loading: false,
      noRecordFound: false,
      totpageNo: "",
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 3,
    });
  }

  paginationinfo(url) {
    this.searchdata(this.state.title_search, url);
  }

  async componentDidMount() {
    this.searchdata(this.state.title_search, this.state.page);
  }

  resetSearch(e) {
    this.setState({ title_search: "" });
    this.searchdata("", 1);
  }

  async searchdata(data, page) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await CataloguePackageActivity(data, page, obj)
      .then((res) => {
        var data = res.data;

        if (res.success == true) {
          var no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              no_pages.push(i);
            } else {
              no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.length == 0) {
            no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1,
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1,
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1,
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1,
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }

          this.setState({
            loading: false,
            activityData: res.data.data,
            totpageNo: data.last_page,
            userRole: token.role,
            paginationData: no_pages,
          });
        } else {
          this.handleNetworkError("bl", res);
        }
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    const activityDetails = this.state.activityData;

    let c = 1;
    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          {this.state.remove_org_alt}
          {this.state.edit_pkg_alt}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                content={
                  <React.Fragment>
                    <Row>
                      <Col md={12} sm={12} lg={12} xs={12}>
                        <Col
                          md={1}
                          sm={1}
                          lg={1}
                          xs={12}
                          className="fl_mb _1"
                          style={{
                            paddingLeft: "18px",
                            width: "18%",
                            position: "relative",
                            right: "6px",
                          }}
                        >
                          <FormControl
                            style={{ textAlign: "center" }}
                            name="title_search"
                            value={this.state.title_search || ""}
                            placeholder="Item Name"
                            onChange={this.onChange}
                            type="text"
                          />
                        </Col>

                        <Col md={3} sm={4} lg={3} xs={12} className="fl_mb_1">
                          <Button
                            class="btn-color" //bsStyle="info"
                            fill
                            onClick={this.searchdata.bind(
                              this,
                              this.state.title_search,
                              1,
                            )}
                          >
                            Filter
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            class="btn-color" //bsStyle="info"
                            fill
                            onClick={this.resetSearch.bind(this)}
                          >
                            Reset
                          </Button>
                        </Col>
                      </Col>

                      <Col md={12}>
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>Log Name</th>
                              <th>Description</th>
                              <th>Created At</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.loading ? (
                              <tr>
                                <td colspan="10">
                                  <LoadingSpinner />
                                </td>
                              </tr>
                            ) : this.state.activityData.length == 0 ? (
                              <tr>
                                <td colspan="10">
                                  <center>No record found</center>
                                </td>
                              </tr>
                            ) : (
                              <React.Fragment>
                                {activityDetails.map((cus, i) => (
                                  <tr key={i}>
                                    <td
                                      key={cus.i}
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {cus.log_name}
                                    </td>
                                    <td>{cus.description}</td>
                                    <td>{cus.created_at}</td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            )}
                          </tbody>
                        </Table>
                        {this.state.loading
                          ? ""
                          : this.state.noRecordFound
                            ? ""
                            : this.state.totpageNo > 0 && (
                                <div style={{ textAlign: "center" }}>
                                  <Pagination>
                                    {!this.state.prevdisabled ? (
                                      <Pagination.First
                                        onClick={this.paginationinfo.bind(
                                          this,
                                          this.state.prevpage,
                                        )}
                                        disabled={this.state.prevdisabled}
                                      />
                                    ) : (
                                      ""
                                    )}
                                    {this.state.paginationData.map((url) => (
                                      <Pagination.Item
                                        active={
                                          this.state.currentPage == c
                                            ? "1"
                                            : null
                                        }
                                        onClick={this.paginationinfo.bind(
                                          this,
                                          url,
                                        )}
                                      >
                                        {c++}
                                      </Pagination.Item>
                                    ))}
                                    {!this.state.nextdisabled ? (
                                      <Pagination.Last
                                        onClick={this.paginationinfo.bind(
                                          this,
                                          this.state.nextpage,
                                        )}
                                        disabled={this.state.nextdisabled}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </Pagination>
                                </div>
                              )}
                      </Col>
                    </Row>
                  </React.Fragment>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default PackageActivity;
